import { capitalize } from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import ReactJsonTree from 'react-json-tree';
import Tabs from 'react-responsive-tabs';
import 'react-responsive-tabs/styles.css';
import { withRouter } from 'react-router-dom';
import { SizeMe } from 'react-sizeme';
import { Card, CardBody } from 'reactstrap';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import PolicyIcon from '@material-ui/icons/Policy';
import SettingIcon from '@material-ui/icons/SettingsEthernet';
import TableIcon from '@material-ui/icons/TableChart';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from 'reactstrap';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import { domainIsTenant as dit } from '../../../../routes/routes';

import {
  parse,
  parseArray,
  safeDeepSet,
  safeGet,
  safeGetWithType,
  stringify,
  stringifyFormatted,
} from 'iotera-base/json';

import { isEmpty, isInteger, isNone, isString } from 'iotera-base/object';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Switch,
} from '@material-ui/core';
import Result from 'iotera-base/result';
import fileDownload from 'js-file-download';
import {
  CustomTableCell,
  TablePaginationActionsWrapped,
} from '../../../../custom/table';
import {
  WEBSERVICE_FETCH,
  isDataConf,
} from '../../../../lib/components/Preference';
import {
  lowercaseSpaceReplace,
  toDate,
} from '../../../../lib/components/formatter';
import { getWidthColumnByPercent } from '../../../../lib/components/function';
import { SubViewHeader } from '../../../../lib/components/subHeader';
import { buildWBoundActions, buildWSelector } from '../../../../redux/ducks';
import { actions as notificationActions } from '../../../../redux/ducks/notification';

import {
  Transition,
  formatDatatypeSelf,
  formatDate,
  formatItemStringUObject,
  formatLabelUObject,
  formatSubparam,
  formatValue,
  formatValueUObject,
  selectKeyUObject,
} from './function';

import JsonEditor from '../../../../lib/components/JsonEditor';
import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from '../../../../lib/components/callbackGlobal';
import { IoteraForm } from '../../../../lib/components/form';
import Policy from './policy';
import TabDateTime from './tab-date-time';
import TabLatest from './tab-latest';
import Tag from './tag';

const DEVICE_DATA = 'FETCH_DATA';
const DEVICE_DATA_RPAYLOAD = 'FETCH_DATA_rpayload';
const EDIT_CONF = 'CONFIGURE';
const DOWNLOAD_DATA_TIME = 'DOWNLOAD_DATA_TIME';
const DOWNLOAD_DATA_NLATEST = 'DOWNLOAD_DATA_NLATEST';
const WKEY = 'DEVICE_DATA_DETAIL';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

// function render tabs
const getTabs = dataTabs => {
  return dataTabs.map((dataTab, i) => ({
    title: safeGet(dataTab, 'titleTabs'),
    getContent: () => safeGet(dataTab, 'contentTabs'),
    key: i,
    tabClassName: '',
    panelClassName: '',
  }));
};

const parseNumber = value => {
  const i = parseInt(value);
  const f = parseFloat(value);
  if (i === NaN || f === NaN) {
    return null;
  } else if (i === f) {
    return i;
  } else {
    return f;
  }
};

const schema = {
  type: 'object',
  required: ['value'],
  properties: {
    value: { type: 'string', title: 'Nilai konfigurasi baru', minLength: 0 },
  },
};

const uiSchema = {
  value: {
    'ui:widget': props => {
      return (
        <div style={{ padding: 1, border: '1px solid #CED4DA' }}>
          <JsonEditor {...props} />
        </div>
      );
    },
  },
};

class DeviceDataTab extends Component {
  constructor(props) {
    super(props);
    const selected = safeGetWithType(this, ['props', 'selected'], {});
    const sensor = safeGetWithType(selected, ['sensor'], '');
    const configtype = safeGetWithType(selected, ['configtype'], '');
    const param = safeGetWithType(selected, ['param'], '');
    const subparam = safeGetWithType(selected, ['subparam'], {});
    const datatype = safeGetWithType(selected, ['datatype'], '');
    const deviceId = safeGetWithType(
      this,
      ['props', 'match', 'params', 'id'],
      ''
    );
    this.state = {
      sensor,
      deviceId,
      configtype,
      param,
      datatype,
      subparam,
      loading: true,
      refresh: false,
    };
    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleCbRefresh = this.handleCbRefresh.bind(this);
    this.handleLoading = this.handleLoading.bind(this);
  }

  handleRefresh() {
    const _this = this;
    _this.setState({
      refresh: true,
    });
  }

  handleCbRefresh(state) {
    this.setState({
      refresh: state,
    });
  }

  handleLoading(state) {
    this.setState({
      loading: state,
    });
  }

  render() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const { sensor, configtype, param, loading, refresh } = _state;
    let { datatype } = _state;
    datatype = capitalize(datatype);
    let dataTabs = [
      {
        titleTabs: 'Nilai Terakhir',
        contentTabs: (
          <TabLatest
            {..._props}
            refresh={refresh}
            cbLoading={_this.handleLoading}
            cbRefresh={_this.handleCbRefresh}
          />
        ),
      },
      {
        titleTabs: 'Waktu',
        contentTabs: (
          <TabDateTime
            {..._props}
            refresh={refresh}
            cbLoading={_this.handleLoading}
            cbRefresh={_this.handleCbRefresh}
          />
        ),
      },
    ];
    const spinner = (
      <div className="centeringItem">
        <ReactLoading type="spinningBubbles" color="#000" />
      </div>
    );
    return (
      <Dialog
        fullScreen
        open={_props.dialogOpen}
        onClose={_props.handleClose}
        TransitionComponent={Transition}
      >
        <Loader
          show={loading}
          message={spinner}
          backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}
        >
          <AppBar style={{ position: 'relative' }}>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={_props.handleClose}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" style={{ flex: 1 }}>
                Data {datatype}
              </Typography>
              <IconButton
                color="inherit"
                onClick={_this.handleRefresh}
                aria-label="Close"
              >
                <RefreshIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <div className="view">
            <div className="view-content-dashboard">
              <div className="d-flex justify-content-end py-0 margin-scp-data-detail">
                <div className="font-weight-semi-bold px-0">
                  <span>{'sensor :​'}&nbsp;</span>
                  <span style={{ color: '#7E57C2', textAlign: 'center' }}>
                    {sensor}
                  </span>
                </div>
                <div className="font-weight-semi-bold px-0 mx-12">
                  <span>{'configtype :'}&nbsp;</span>
                  <span style={{ color: '#7E57C2', textAlign: 'center' }}>
                    {configtype}
                  </span>
                </div>
                <div className="font-weight-semi-bold px-0">
                  <span>{'param :'}&nbsp;</span>
                  <span style={{ color: '#7E57C2', textAlign: 'center' }}>
                    {param}
                  </span>
                </div>
              </div>
              <Tabs items={getTabs(dataTabs)} showInkBar />
            </div>
          </div>
        </Loader>
      </Dialog>
    );
  }
}

class DeviceData extends Component {
  constructor(props) {
    super(props);
    moment.locale('id');
    let today = moment();
    let lastMonth = moment().subtract(1, 'months');
    this.state = {
      navMini: false,
      loading: true,
      page: 0,
      rowsPerPage: 100,
      dropdownOpen: {},
      dialogOpen: false,
      dialogInputOpen: false,
      dialogDownload: false,
      dialogUObject: false,
      dialogPolicy: false,
      dialogTag: false,
      selectedItem: {},
      selectedKey: '',
      downloadMethod: 'time',
      nData: 50,
      startDate: lastMonth,
      endDate: today,
      isDownloadable: true,
      valueInput: null,
      formData: {},
      dataUObject: {},
    };
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClickDownload = this.handleClickDownload.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleClickOpenInput = this.handleClickOpenInput.bind(this);
    this.handleCloseInput = this.handleCloseInput.bind(this);
    this.handleSubmitInput = this.handleSubmitInput.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.handleChangeMethod = this.handleChangeMethod.bind(this);
    this.handleChangeNData = this.handleChangeNData.bind(this);
    this.handleClickUObject = this.handleClickUObject.bind(this);
    this.handleCloseUObject = this.handleCloseUObject.bind(this);
    this.selectionFormData = this.selectionFormData.bind(this);
  }

  handleClickUObject = (key, item) => () => {
    let finalValue = {};
    const value = safeGet(item, 'value', {});
    if (isString(value)) {
      finalValue = parse(value);
    } else {
      finalValue = value;
    }
    this.setState({
      dataUObject: finalValue,
      dialogUObject: true,
      selectedItem: item,
      selectedKey: key,
    });
  };

  handleExpandNode = () => false;

  handleCloseUObject = () => {
    this.setState({ dialogUObject: false });
  };

  onChangeDate(date) {
    let startDate = safeGet(date, ['startDate']);
    let endDate = safeGet(date, ['endDate']);
    let isDownloadable;
    if (
      startDate !== null &&
      endDate !== null &&
      startDate !== undefined &&
      endDate !== undefined
    ) {
      isDownloadable = true;
    } else {
      isDownloadable = false;
    }
    this.setState({
      startDate: date.startDate,
      endDate: date.endDate,
      isDownloadable,
    });
  }

  handleChangeInput = item => event => {
    const _this = this;
    let datatype = safeGet(item, ['datatype']);
    if (datatype === 'uobject' || datatype === 'object') {
      _this.setState({ formData: event.formData });
    } else {
      _this.setState({ valueInput: event.target.value });
    }
  };

  handleChangeToggle = value => {
    this.setState({ valueInput: value });
  };

  handleChangeNData = event => {
    let nData = safeGetWithType(event, ['target', 'value'], '50');
    let nDataInt = parseInt(nData, 10);
    let isDownloadable = true;
    if (isNaN(nDataInt)) {
      nDataInt = 0;
      isDownloadable = false;
    } else if (nDataInt < 1 || nDataInt > 5000) {
      isDownloadable = false;
    }
    this.setState({ nData: nDataInt, isDownloadable });
  };

  handleChangeMethod = event => {
    let downloadMethod = safeGetWithType(event, ['target', 'value'], 'time');
    this.setState({ downloadMethod });
  };

  handleClickOpenInput = (key, selectedItem) => () => {
    const _this = this;
    const _state = _this.state;
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden
    dropdownOpen[key] = false;
    this.setState({
      dropdownOpen,
      dialogInputOpen: true,
      selectedItem,
      selectedKey: key,
    });
  };

  handleClickDownload = (key, selectedItem) => () => {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    let dataFound = safeGetWithType(selectedItem, ['data_exist'], false);
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden
    dropdownOpen[key] = false;
    // TODO after upload service
    if (dataFound === false) {
      _props.showSingleNotification({
        message: 'Data dari konfigurasi ini masih kosong',
        level: 'warning',
      });
      _this.setState({ dropdownOpen });
      return;
    }
    _this.setState({
      dropdownOpen,
      dialogDownload: true,
      selectedItem,
      selectedKey: key,
    });
  };

  handleCloseDownload = () => {
    this.setState({
      dropdownOpen: {},
      dialogDownload: false,
      selectedKey: '',
      selectedItem: {},
    });
  };

  handleSubmitDownload = _this => () => {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const deviceId = safeGetWithType(_props, ['match', 'params', 'id'], '');
    if (deviceId === '') {
      return;
    }
    let startDate = safeGet(_state, ['startDate']);
    let endDate = safeGet(_state, ['endDate']);
    startDate = startDate.valueOf();
    endDate = endDate.valueOf();
    let sensor = safeGetWithType(_state, ['selectedItem', 'sensor'], '');
    let configtype = safeGetWithType(
      _state,
      ['selectedItem', 'configtype'],
      ''
    );
    let param = safeGetWithType(_state, ['selectedItem', 'param'], '');
    let downloadMethod = safeGetWithType(_state, ['downloadMethod'], 'time');
    let ndata = safeGetWithType(_state, ['nData'], 50);
    if (downloadMethod === 'time') {
      _props.wSingleRequestCall({
        id: DOWNLOAD_DATA_TIME,
        params: {
          device_id: deviceId,
          start: startDate,
          end: endDate,
          sensor,
          configtype,
          param,
        },
      });
    } else if (downloadMethod === 'ndata') {
      _props.wSingleRequestCall({
        id: DOWNLOAD_DATA_NLATEST,
        params: {
          device_id: deviceId,
          sensor,
          configtype,
          param,
          ndata,
        },
      });
    }
    _this.setState({ dropdownOpen: {}, dialogDownload: false, loading: true });
  };

  handleCloseInput = () => {
    this.setState({
      dropdownOpen: {},
      dialogInputOpen: false,
      selectedKey: '',
      selectedItem: {},
      valueInput: null,
      formData: {},
    });
  };

  handleSubmitInput = (_this, currValue) => () => {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const deviceId = safeGetWithType(_props, ['match', 'params', 'id'], '');
    if (deviceId === '') {
      return;
    }
    let sensor = safeGetWithType(_state, ['selectedItem', 'sensor'], '');
    let configtype = safeGetWithType(
      _state,
      ['selectedItem', 'configtype'],
      ''
    );
    let param = safeGetWithType(_state, ['selectedItem', 'param'], '');
    let datatype = safeGetWithType(_state, ['selectedItem', 'datatype'], '');
    let value = safeGet(_state, ['valueInput']);
    if (currValue !== null) {
      if (value === null) {
        value = currValue;
      }
    }
    if (datatype === 'number') {
      value = parseNumber(value);
    } else if (datatype === 'object' || datatype === 'uobject') {
      let submitData = safeGet(_state, ['formData']);
      if (isEmpty(submitData)) {
        submitData = currValue;
      }
      let valueData = safeGetWithType(submitData, ['value']);
      let value_object = parse(valueData);
      if (isNone(value_object)) {
        value_object = parseArray(valueData);
      }
      if (isNone(value_object)) {
        submitData['value'] = stringify(value_object);
        _props.showSingleNotification({
          message: 'Konfigurasi harus dalam bentuk JSON yang benar',
          level: 'warning',
        });
        _this.setState({ formData: submitData });
        return;
      }
      value = value_object;
      submitData['value'] = stringifyFormatted(value_object);
      _this.setState({ formData: submitData });
    }
    if (isNone(value)) {
      _props.showSingleNotification({
        message: 'Input error',
        level: 'warning',
      });
    }
    _props.wSingleRequestCall({
      id: EDIT_CONF,
      body: {
        sensor,
        configtype,
        param,
        value,
      },
    });
    _this.setState({
      dropdownOpen: {},
      dialogInputOpen: false,
      selectedItem: {},
      valueInput: null,
      formData: {},
    });
  };

  handleClickOpen = (key, selectedItem) => () => {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const dataFound = safeGetWithType(selectedItem, ['data_exist'], false);
    const dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden
    dropdownOpen[key] = false;
    // TODO after upload service
    // if (dataFound === false) {
    //   _props.showSingleNotification({ message: 'Data atau Konfigurasi dari sensor ini masih kosong', level: 'warning' });
    //   _this.setState({ dropdownOpen });
    //   return;
    // }
    _this.setState({ dropdownOpen, dialogOpen: true, selectedItem });
  };

  handleClickPolicy = (key, selectedItem) => () => {
    const _this = this;
    const _state = _this.state;
    const dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden
    dropdownOpen[key] = false;
    _this.setState({ dropdownOpen, dialogPolicy: true, selectedItem });
  };

  handleClosePolicy = () => {
    this.setState({ dialogPolicy: false });
  };

  handleClickPenanda = (key, selectedItem) => () => {
    const _this = this;
    const _state = _this.state;
    const dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden
    dropdownOpen[key] = false;
    _this.setState({ dropdownOpen, dialogTag: true, selectedItem });
  };

  handleCloseTag = () => {
    this.setState({ dialogTag: false });
  };

  handleClose = () => {
    this.setState({ dialogOpen: false });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage)) rowsPerPage = parseInt(rowsPerPage);
    this.setState({ page: 0, rowsPerPage });
  };

  onMouseEnter = key => () => {
    const _this = this;
    const _state = _this.state;
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown visible
    dropdownOpen[key] = true;
    _this.setState({ dropdownOpen });
  };

  onMouseLeave = key => () => {
    const _this = this;
    const _state = _this.state;
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden
    dropdownOpen[key] = false;
    _this.setState({ dropdownOpen });
  };

  selectionFormData(item, formData) {
    let dataToShow = {};
    if (!isEmpty(formData)) {
      dataToShow = formData;
    } else {
      if (!isEmpty(item)) {
        dataToShow = item;
      }
    }
    return dataToShow;
  }

  goTo(link) {
    const _props = this.props;
    if (link === 'delete') {
      _props.showSingleNotification({
        message: 'Maaf, fitur hapus perangkat belum tersedia',
        position: 'tr',
        level: 'info',
      });
    } else if (link === 'emptyTag') {
      _props.showSingleNotification({
        message: 'Maaf, fitur hapus perangkat belum tersedia',
        position: 'tr',
        level: 'info',
      });
    } else {
      _props.history.push(link);
    }
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const deviceId = safeGet(_props, ['match', 'params', 'id']);
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props);
    _props.wSetConfig({
      single_config: {
        [EDIT_CONF]: {
          wparam: {
            ...domainIsTenant,
            method: 'POST',
            type: WEBSERVICE_FETCH,
            path: '/fetch/web/device/p/' + deviceId,
            timeout: 60000,
          },
          wcallback: {
            started: function () {
              _props.showSingleNotification({
                message: 'Konfigurasi sedang dikirim. Mohon tunggu',
                position: 'tr',
                level: 'info',
              });
              _this.setState({ loading: true });
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(
                  result,
                  ['body', 'response_result'],
                  Result.UNKNOWN_ERROR
                );
                if (responseResult === Result.SUCCESS) {
                  _props.showSingleNotification({
                    message: 'Konfigurasi berhasil',
                    position: 'tr',
                    level: 'success',
                  });
                  _this.setState({
                    data: safeGetWithType(result, ['body', 'data'], []),
                    loading: false,
                  });
                } else {
                  _props.showSingleNotification({
                    message: 'Konfigurasi gagal',
                    position: 'tr',
                    level: 'error',
                  });
                  _this.setState({
                    loading: false,
                  });
                }
              } else {
                _props.showSingleNotification({
                  message: 'Konfigurasi gagal',
                  position: 'tr',
                  level: 'error',
                });
                _this.setState({
                  loading: false,
                });
              }
            },
          },
        },
        [DOWNLOAD_DATA_TIME]: {
          wparam: {
            ...domainIsTenant,
            type: WEBSERVICE_FETCH,
            responseType: 'text',
            path: '/fetch/web/file/csv/period/' + deviceId,
            timeout: 60000,
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const deviceInfo = safeGet(_this, [
                  'props',
                  'items',
                  DEVICE_DATA_RPAYLOAD,
                ]);
                let devName = safeGet(
                  deviceInfo,
                  ['device_label'],
                  'Data_perangkat'
                );
                devName = lowercaseSpaceReplace(devName);
                let devId = safeGet(deviceInfo, ['device_id'], '');
                if (devId !== '') {
                  devId = '_' + devId;
                }
                let selected = safeGetWithType(_state, ['selectedItem'], {});
                let sensor = safeGetWithType(selected, ['sensor'], '');
                if (sensor !== '') {
                  sensor = '_' + sensor;
                }
                let configtype = safeGetWithType(selected, ['configtype'], '');
                if (configtype !== '') {
                  configtype = '_' + configtype;
                }
                let param = safeGetWithType(selected, ['param'], '');
                if (param !== '') {
                  param = '_' + param;
                }

                let now = moment().unix() * 1000;
                let nowString = toDate(now, 'YYYYMMDD_HHmmss');
                let fileName =
                  devName +
                  '_' +
                  nowString +
                  devId +
                  sensor +
                  configtype +
                  param +
                  '.csv';
                let csvDataString = safeGetWithType(result, ['body'], '');
                _props.showSingleNotification({
                  message: 'Download sedang dilakukan',
                  position: 'tr',
                  level: 'info',
                });
                _this.setState({
                  loading: false,
                });
                return fileDownload(csvDataString, fileName);
              } else {
                _props.showSingleNotification({
                  message: 'Download gagal',
                  position: 'tr',
                  level: 'error',
                });
                _this.setState({
                  loading: false,
                });
              }
            },
          },
        },
        [DOWNLOAD_DATA_NLATEST]: {
          wparam: {
            ...domainIsTenant,
            type: WEBSERVICE_FETCH,
            responseType: 'text',
            path: '/fetch/web/file/csv/nlatest/' + deviceId,
            timeout: 60000,
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const deviceInfo = safeGet(_this, [
                  'props',
                  'items',
                  DEVICE_DATA_RPAYLOAD,
                ]);
                let devName = safeGet(
                  deviceInfo,
                  ['device_label'],
                  'Data_perangkat'
                );
                devName = lowercaseSpaceReplace(devName);
                let devId = safeGet(deviceInfo, ['device_id'], '');
                if (devId !== '') {
                  devId = '_' + devId;
                }
                let selected = safeGetWithType(_state, ['selectedItem'], {});
                let sensor = safeGetWithType(selected, ['sensor'], '');
                if (sensor !== '') {
                  sensor = '_' + sensor;
                }
                let configtype = safeGetWithType(selected, ['configtype'], '');
                if (configtype !== '') {
                  configtype = '_' + configtype;
                }
                let param = safeGetWithType(selected, ['param'], '');
                if (param !== '') {
                  param = '_' + param;
                }
                let now = moment().unix() * 1000;
                let nowString = toDate(now, 'YYYYMMDD_HHmmss');
                let fileName =
                  devName +
                  '_' +
                  nowString +
                  devId +
                  sensor +
                  configtype +
                  param +
                  '.csv';
                let csvDataString = safeGetWithType(result, ['body'], '');
                _props.showSingleNotification({
                  message: 'Download sedang dilakukan',
                  position: 'tr',
                  level: 'info',
                });
                _this.setState({
                  loading: false,
                });
                return fileDownload(csvDataString, fileName);
              } else {
                _props.showSingleNotification({
                  message: 'Download gagal',
                  position: 'tr',
                  level: 'error',
                });
                _this.setState({
                  loading: false,
                });
              }
            },
          },
        },
      },
      background_config: {
        [DEVICE_DATA]: {
          wparam: {
            ...domainIsTenant,
            type: WEBSERVICE_FETCH,
            path: '/fetch/web/device/data/list/' + deviceId,
          },
          wcallback: {
            finished: function (id, result) {
              let item = safeGet(result, ['body']);
              let data = safeGet(result, ['body', 'data']);
              for (let i in data) {
                let datatype = safeGet(data, [i, 'datatype']);
                if (
                  datatype === 'uobject' ||
                  datatype === 'object' ||
                  datatype === 'image' ||
                  datatype === 'mobject' ||
                  datatype === 'surveillance'
                ) {
                  let value = stringifyFormatted(
                    safeGet(data, [i, 'value'], {})
                  );
                  data[i]['value'] = value;
                }
              }
              safeDeepSet(item, ['data'], data);
              // TODO Loading
              _this.setState({
                loading: false,
              });
              return item;
            },
          },
          wreducer: {
            rparse: function (id, result, rpayload) {
              let item = rpayload;
              let data = safeGet(item, ['data']);
              for (let i in data) {
                let datatype = safeGet(data, [i, 'datatype']);
                if (
                  datatype === 'uobject' ||
                  datatype === 'object' ||
                  datatype === 'image' ||
                  datatype === 'mobject' ||
                  datatype === 'surveillance'
                ) {
                  let value = stringifyFormatted(
                    safeGet(data, [i, 'value'], {})
                  );
                  data[i]['value'] = value;
                }
              }
              safeDeepSet(item, ['data'], data);
              return item;
            },
          },
        },
      },
    });
  }

  componentWillUnmount() {
    const _props = this.props;
    // callback global
    unsetCallbackGlobal(_props);
    _props.wUnsetConfig({ key: WKEY });
  }

  shouldShowExpandanble(dt, sdts) {
    if (dt === 'uobject' || dt === 'image' || dt === 'mobject' || dt === 'surveillance') {
      return true;
    } else if (dt === 'object' && !isNone(sdts)) {
      for (let subparam in sdts) {
        const sdt = safeGet(sdts, subparam)
        if (sdt === 'uobject') {
          return true;
        }
      }
    }
    return false;
  }

  render() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state;
    const data = safeGet(_props, ['items', DEVICE_DATA_RPAYLOAD, 'data'], []);
    const title = safeGet(
      _props,
      ['items', DEVICE_DATA_RPAYLOAD, 'device_label'],
      'Detail Perangkat'
    );
    const subTitle = safeGet(
      _props,
      ['items', DEVICE_DATA_RPAYLOAD, 'device_id'],
      ''
    );
    const {
      rowsPerPage,
      page,
      loading,
      formData,
      dataUObject,
      dialogOpen,
      dialogPolicy,
      dialogTag,
      selectedItem,
    } = _state;
    const spinner = (
      <div className="centeringItem">
        <ReactLoading type="spinningBubbles" color="#000" />
      </div>
    );
    return (
      <Loader
        show={loading}
        message={spinner}
        backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}
      >
        <div className="view">
          <SubViewHeader title={title} subTitle={subTitle} />
          <div className="view-content-dashboard">
            <Card>
              <SizeMe>
                {({ size }) => (
                  <CardBody>
                    <div className="table-responsive">
                      <Table className="table">
                        <TableHead style={{ height: 0 }}>
                          <TableRow>
                            <CustomTableCell
                              style={{
                                minWidth: getWidthColumnByPercent(
                                  10,
                                  size.width - 140
                                ),
                                maxWidth: getWidthColumnByPercent(
                                  10,
                                  size.width - 140
                                ),
                              }}
                            >
                              sensor
                            </CustomTableCell>
                            <CustomTableCell
                              style={{
                                minWidth: getWidthColumnByPercent(
                                  10,
                                  size.width - 140
                                ),
                                maxWidth: getWidthColumnByPercent(
                                  10,
                                  size.width - 140
                                ),
                              }}
                            >
                              configtype
                            </CustomTableCell>
                            <CustomTableCell
                              style={{
                                minWidth: getWidthColumnByPercent(
                                  10,
                                  size.width - 140
                                ),
                                maxWidth: getWidthColumnByPercent(
                                  10,
                                  size.width - 140
                                ),
                              }}
                            >
                              param
                            </CustomTableCell>
                            <CustomTableCell
                              style={{
                                minWidth: getWidthColumnByPercent(
                                  10,
                                  size.width - 140
                                ),
                                maxWidth: getWidthColumnByPercent(
                                  10,
                                  size.width - 140
                                ),
                              }}
                            >
                              datatype
                            </CustomTableCell>
                            <CustomTableCell
                              style={{
                                minWidth: getWidthColumnByPercent(
                                  20,
                                  size.width - 140
                                ),
                                maxWidth: getWidthColumnByPercent(
                                  20,
                                  size.width - 140
                                ),
                              }}
                            >
                              subparam
                            </CustomTableCell>
                            <CustomTableCell
                              style={{
                                minWidth: getWidthColumnByPercent(
                                  20,
                                  size.width - 140
                                ),
                                maxWidth: getWidthColumnByPercent(
                                  20,
                                  size.width - 140
                                ),
                              }}
                            >
                              value
                            </CustomTableCell>
                            <CustomTableCell
                              style={{
                                minWidth: getWidthColumnByPercent(
                                  15,
                                  size.width - 140
                                ),
                                maxWidth: getWidthColumnByPercent(
                                  15,
                                  size.width - 140
                                ),
                              }}
                            >
                              last updated
                            </CustomTableCell>
                            <CustomTableCell
                              style={{
                                textAlign: 'center',
                                minWidth: getWidthColumnByPercent(
                                  5,
                                  size.width - 140
                                ),
                                maxWidth: getWidthColumnByPercent(
                                  5,
                                  size.width - 140
                                ),
                              }}
                            >
                              <span>action</span>
                            </CustomTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {data
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((item, i) => (
                              <TableRow
                                key={i}
                                className="table-row-child-iotera"
                              >
                                <TableCell>
                                  <div style={{ fontWeight: 500 }}>
                                    {item.sensor}
                                  </div>
                                </TableCell>
                                <TableCell>
                                  <div style={{ fontWeight: 500 }}>
                                    {item.configtype}
                                  </div>
                                </TableCell>
                                <TableCell>
                                  <div style={{ fontWeight: 500 }}>
                                    {item.param}
                                  </div>
                                </TableCell>
                                <TableCell>
                                  <div>{formatDatatypeSelf(item.datatype)}</div>
                                </TableCell>
                                <TableCell>
                                  {formatSubparam(item.subparam_datatypes)}
                                </TableCell>
                                <TableCell>
                                  {this.shouldShowExpandanble(item.datatype, item.subparam_datatypes) ? (
                                    <Button
                                      onClick={_this.handleClickUObject(
                                        i,
                                        item
                                      )}
                                    >
                                      {' '}
                                      {`{...}`}{' '}
                                    </Button>
                                  ) : item.datatype === 'object' ? (
                                    formatValue(
                                      item.data_exist,
                                      item.datatype,
                                      parse(item.value),
                                      item.subparam_datatypes
                                    )
                                  ) : (
                                    formatValue(
                                      item.data_exist,
                                      item.datatype,
                                      item.value,
                                      item.subparam_datatypes
                                    )
                                  )}
                                  {i === _state.selectedKey ? (
                                    <Dialog
                                      open={_state.dialogUObject}
                                      onClose={_this.handleCloseUObject}
                                      aria-labelledby="uobject-dialog-title"
                                      aria-describedby="uobject-dialog-description"
                                      fullWidth={true}
                                      maxWidth={'md'}
                                    >
                                      <DialogTitle id="uobject-dialog-title">
                                        {' '}
                                        {`${selectedItem.sensor}:${selectedItem.configtype}:${selectedItem.param}`}{' '}
                                      </DialogTitle>
                                      <DialogContent className="dialog-content-uobject">
                                        <ReactJsonTree
                                          data={dataUObject}
                                          theme={{
                                            tree: ({ style }) => ({
                                              style: {
                                                ...style,
                                                backgroundColor: undefined,
                                              }, // removing default background color from styles
                                            }),
                                          }}
                                          getItemString={(
                                            type,
                                            data,
                                            itemType,
                                            itemString
                                          ) =>
                                            formatItemStringUObject(
                                              type,
                                              data,
                                              itemType,
                                              itemString
                                            )
                                          }
                                          keyPath={[selectKeyUObject(item)]}
                                          shouldExpandNode={
                                            _this.handleExpandNode
                                          }
                                          labelRenderer={([key]) =>
                                            formatLabelUObject(key)
                                          }
                                          valueRenderer={value =>
                                            formatValueUObject(value)
                                          }
                                        />
                                      </DialogContent>
                                    </Dialog>
                                  ) : null}
                                </TableCell>
                                <TableCell>
                                  <Tooltip
                                    title={item.data_exist ? item.ts : ''}
                                    leaveDelay={500}
                                    interactive
                                  >
                                    <span>
                                      {formatDate(item.data_exist, item.ts)}
                                    </span>
                                  </Tooltip>
                                </TableCell>
                                <TableCell
                                  style={{ textAlign: 'center' }}
                                  onMouseLeave={_this.onMouseLeave(i)}
                                >
                                  <UncontrolledDropdown
                                    isOpen={safeGetWithType(
                                      _state,
                                      ['dropdownOpen', i],
                                      false
                                    )}
                                  >
                                    <DropdownToggle tag="div">
                                      <IconButton
                                        onMouseOver={_this.onMouseEnter(i)}
                                        style={{
                                          cursor: 'pointer',
                                          padding: 4,
                                        }}
                                      >
                                        <MoreIcon
                                          color="inherit"
                                          style={{ height: 30, width: 30 }}
                                        />
                                      </IconButton>
                                    </DropdownToggle>
                                    <DropdownMenu
                                      style={{ padding: 0, margin: 0 }}
                                    >
                                      <DropdownItem
                                        style={{ margin: 0 }}
                                        onClick={_this.handleClickOpen(i, item)}
                                      >
                                        <TableIcon
                                          color="inherit"
                                          style={{ height: 18, width: 18 }}
                                        />
                                        &emsp;
                                        <span style={{ marginRight: 20 }}>
                                          Lihat Data
                                        </span>
                                      </DropdownItem>
                                      {!isDataConf(item.configtype) ? (
                                        <DropdownItem
                                          style={{ margin: 0 }}
                                          onClick={_this.handleClickOpenInput(
                                            i,
                                            item
                                          )}
                                        >
                                          <SettingIcon
                                            color="inherit"
                                            style={{ height: 18, width: 18 }}
                                          />
                                          &emsp;
                                          <span style={{ marginRight: 20 }}>
                                            Konfigurasi
                                          </span>
                                        </DropdownItem>
                                      ) : null}
                                      {item.datatype !== 'image' ||
                                      item.datatype !== 'mobject' ? (
                                        <DropdownItem
                                          style={{ margin: 0 }}
                                          onClick={_this.handleClickDownload(
                                            i,
                                            item
                                          )}
                                        >
                                          <DownloadIcon
                                            color="inherit"
                                            style={{ height: 18, width: 18 }}
                                          />
                                          &emsp;
                                          <span style={{ marginRight: 20 }}>
                                            Download
                                          </span>
                                        </DropdownItem>
                                      ) : null}
                                      <DropdownItem
                                        style={{ margin: 0 }}
                                        onClick={_this.handleClickPolicy(
                                          i,
                                          item
                                        )}
                                      >
                                        <PolicyIcon
                                          color="inherit"
                                          style={{ height: 18, width: 18 }}
                                        />
                                        &emsp;
                                        <span style={{ marginRight: 20 }}>
                                          Policy
                                        </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        style={{ margin: 0 }}
                                        onClick={_this.handleClickPenanda(
                                          i,
                                          item
                                        )}
                                      >
                                        <LocalOfferIcon
                                          color="inherit"
                                          style={{ height: 18, width: 18 }}
                                        />
                                        &emsp;
                                        <span style={{ marginRight: 20 }}>
                                          Penanda
                                        </span>
                                      </DropdownItem>
                                    </DropdownMenu>
                                    {i === _state.selectedKey &&
                                    !isDataConf(item.configtype) ? (
                                      item.datatype === 'object' ||
                                      item.datatype === 'uobject' ? (
                                        <Dialog
                                          open={_state.dialogInputOpen}
                                          onClose={_this.handleCloseInput}
                                          aria-labelledby="config-iotera-form-dialog-title"
                                          maxWidth={'md'}
                                        >
                                          <DialogTitle id="config-iotera-form-dialog-title">
                                            Ubah Konfigurasi
                                          </DialogTitle>
                                          <DialogContent className="dialog-content-uobject">
                                            <IoteraForm
                                              schema={schema}
                                              uiSchema={uiSchema}
                                              onChange={_this.handleChangeInput(
                                                item
                                              )}
                                              formData={_this.selectionFormData(
                                                item,
                                                formData
                                              )}
                                              onSubmit={_this.handleSubmitInput(
                                                _this,
                                                item
                                              )}
                                            >
                                              <div className="button-right">
                                                <Button
                                                  onClick={
                                                    _this.handleCloseInput
                                                  }
                                                  color="primary"
                                                >
                                                  Batal
                                                </Button>
                                                <Button
                                                  type="submit"
                                                  variant="contained"
                                                  color="primary"
                                                >
                                                  Simpan
                                                </Button>
                                              </div>
                                            </IoteraForm>
                                          </DialogContent>
                                        </Dialog>
                                      ) : (
                                        <Dialog
                                          open={_state.dialogInputOpen}
                                          onClose={_this.handleCloseInput}
                                          aria-labelledby="form-dialog-title"
                                        >
                                          <DialogTitle id="form-dialog-title">
                                            Ubah Konfigurasi
                                          </DialogTitle>
                                          <DialogContent>
                                            <DialogContentText>
                                              'Masukkan nilai konfigurasi baru.'
                                            </DialogContentText>
                                            {item.datatype === 'number' ? (
                                              <TextField
                                                autoFocus
                                                margin="dense"
                                                id="name"
                                                label="Nilai konfigurasi baru"
                                                type="number"
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                                defaultValue={parseNumber(
                                                  item.value
                                                ).toString()}
                                                fullWidth
                                                onChange={_this.handleChangeInput(
                                                  item
                                                )}
                                              />
                                            ) : item.datatype === 'boolean' ? (
                                              <FormControl
                                                required
                                                style={{
                                                  minWidth: '100%',
                                                  marginTop: 10,
                                                }}
                                              >
                                                <span>
                                                  <i>False</i>
                                                  <Switch
                                                    defaultChecked={item.value}
                                                    color="primary"
                                                    onChange={(event, value) =>
                                                      _this.handleChangeToggle(
                                                        value
                                                      )
                                                    }
                                                  />
                                                  <i>True</i>
                                                </span>
                                              </FormControl>
                                            ) : (
                                              <TextField
                                                autoFocus
                                                margin="dense"
                                                id="name"
                                                defaultValue={item.value}
                                                label="Nilai konfigurasi baru"
                                                fullWidth
                                                onChange={_this.handleChangeInput(
                                                  item
                                                )}
                                              />
                                            )}
                                          </DialogContent>
                                          <DialogActions>
                                            <Button
                                              onClick={_this.handleCloseInput}
                                              color="primary"
                                            >
                                              Batal
                                            </Button>
                                            <Button
                                              onClick={_this.handleSubmitInput(
                                                _this,
                                                item.value
                                              )}
                                              variant="contained"
                                              color="primary"
                                            >
                                              Simpan
                                            </Button>
                                          </DialogActions>
                                        </Dialog>
                                      )
                                    ) : null}
                                    {i === _state.selectedKey ? (
                                      <Dialog
                                        open={_state.dialogDownload}
                                        onClose={_this.handleCloseDownload}
                                        aria-labelledby="max-width-dialog-title"
                                        fullWidth={true}
                                        maxWidth={'md'}
                                      >
                                        <DialogTitle id="form-dialog-title">
                                          Download Data
                                        </DialogTitle>
                                        <DialogContent
                                          style={{
                                            minHeight: '500px',
                                            minWidth: '800px',
                                            maxWidth: '800px',
                                          }}
                                        >
                                          <DialogContentText>
                                            {
                                              'Jumlah data yang didownload berdasarkan'
                                            }
                                          </DialogContentText>
                                          <RadioGroup
                                            aria-label="Jumlah data yang didownload berdasarkan"
                                            name="Jumlah data yang didownload berdasarkan"
                                            value={_state.downloadMethod}
                                            row
                                            onChange={e =>
                                              _this.handleChangeMethod(e)
                                            }
                                          >
                                            <FormControlLabel
                                              value="time"
                                              control={
                                                <Radio color="primary" />
                                              }
                                              label="Waktu"
                                            />
                                            <FormControlLabel
                                              value="ndata"
                                              control={
                                                <Radio color="primary" />
                                              }
                                              label="Jumlah Data Terakhir"
                                            />
                                          </RadioGroup>
                                          {_state.downloadMethod === 'time' ? (
                                            <div>
                                              <DialogContentText>
                                                {'Pilih jangka waktu'}
                                              </DialogContentText>
                                              <DateRangePicker
                                                startDate={_state.startDate} // momentPropTypes.momentObj or null,
                                                startDateId="start" // PropTypes.string.isRequired,
                                                endDate={_state.endDate} // momentPropTypes.momentObj or null,
                                                endDateId="end" // PropTypes.string.isRequired,
                                                isOutsideRange={() => false}
                                                startDatePlaceholderText="awal"
                                                endDatePlaceholderText="akhir"
                                                onDatesChange={({
                                                  startDate,
                                                  endDate,
                                                }) =>
                                                  _this.onChangeDate({
                                                    startDate,
                                                    endDate,
                                                  })
                                                } // PropTypes.func.isRequired,
                                                focusedInput={
                                                  _state.focusedInput
                                                } // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                onFocusChange={focusedInput =>
                                                  _this.setState({
                                                    focusedInput,
                                                  })
                                                } // PropTypes.func.isRequired,
                                                small={true}
                                                styles={{
                                                  border:
                                                    '0px solid transparent',
                                                  zIndex: 1400,
                                                }}
                                              />
                                            </div>
                                          ) : (
                                            <TextField
                                              autoFocus
                                              margin="dense"
                                              id="name"
                                              label="Jumlah data"
                                              type="number"
                                              InputLabelProps={{
                                                shrink: true,
                                              }}
                                              defaultValue={_state.nData}
                                              fullWidth
                                              onChange={_this.handleChangeNData}
                                            />
                                          )}
                                        </DialogContent>
                                        <DialogActions>
                                          <Button
                                            onClick={_this.handleCloseDownload}
                                            color="primary"
                                          >
                                            Batal
                                          </Button>
                                          <Button
                                            disabled={!_state.isDownloadable}
                                            onClick={_this.handleSubmitDownload(
                                              _this
                                            )}
                                            variant="contained"
                                            color="primary"
                                          >
                                            Simpan
                                          </Button>
                                        </DialogActions>
                                      </Dialog>
                                    ) : null}
                                  </UncontrolledDropdown>
                                </TableCell>
                              </TableRow>
                            ))}
                          {dialogOpen ? (
                            <DeviceDataTab
                              {..._props}
                              dialogOpen={dialogOpen}
                              handleClose={_this.handleClose}
                              selected={selectedItem}
                            />
                          ) : null}
                          {dialogPolicy ? (
                            <Policy
                              {..._props}
                              dialogPolicy={dialogPolicy}
                              handleClose={_this.handleClosePolicy}
                              selected={selectedItem}
                            />
                          ) : null}
                          {dialogTag ? (
                            <Tag
                              {..._props}
                              dialogTag={dialogTag}
                              handleClose={_this.handleCloseTag}
                              selected={selectedItem}
                            />
                          ) : null}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              labelDisplayedRows={({ from, to, count }) =>
                                `${from}-${to} dari ${count}`
                              }
                              labelRowsPerPage="Baris terlihat:"
                              rowsPerPageOptions={[100, 150, 200]}
                              count={data.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                native: true,
                              }}
                              onPageChange={_this.handleChangePage}
                              onChangeRowsPerPage={
                                _this.handleChangeRowsPerPage
                              }
                              ActionsComponent={TablePaginationActionsWrapped}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </div>
                  </CardBody>
                )}
              </SizeMe>
            </Card>
          </div>
        </div>
      </Loader>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    items: wSelector.getMappedState(state),
  };
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DeviceData));
